import { makeStyles } from "@material-ui/core";
import { color } from "../../../assets/const/color";
export const useStyles = makeStyles(() => ({
  myClass: {
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.gray} !important`,
      borderRadius: "50px !important",
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
      color: `${color.gray} !important`,
    },
    "& .MuiTableHead-root": {
      background: "#FEB62C",
      "& .MuiTableCell-root": {
        color: `${color.white} !important`,
        fontFamily: "inter",
      },
      "& :first-child": {
        borderRadius: "10px 0px 0px 0px !important",
      },
      "& :last-child": {
        borderRadius: "0px 10px 0px 0px !important",
      },
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      fontFamily: "inter !important",
    },
    // padding:"8px",
  },
  add_course_text: {
    fontFamily: "inter !important",
    fontSize: "18px !important",
    fontWeight: "700 !important",
    color: "#00473E",
  },
  label: {
    color: "#374151",
    fontFamily: "inter !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
  },
  form_add_course: {
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
  },
  add_arrival: {
    width: "150px",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },
  error: {
    color: "red",
    fontSize: "12px",
  },
  inputError: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgb(255 0 0 / 48%)",
    },
    "& .MuiOutlinedInput-root.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
    "& .MuiOutlinedInput-root:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
  },
  startTime: {
    width: "220px",
    "& .rc-time-picker-input": {
      padding: "25px !important",
      borderRadius: "50px !important",
      fontFamily: "inter !important",
      fontSize: "15px",
      fontWeight: "500",
    },
    "& .rc-time-picker-clear": {
      top: "14px !important",
    },
  },
  endTime: {
    width: "220px",
    "& .rc-time-picker-input": {
      padding: "25px !important",
      borderRadius: "50px !important",
      fontFamily: "inter !important",
      fontSize: "15px",
      fontWeight: "500",
    },
    "& .rc-time-picker-clear": {
      top: "14px !important",
    },
  },
  // form_content: {
  //   padding: "20px"
  // }

  // cal_wrp: {
  //   position: "relative",
  //   backgroundColor: "white",
  //   marginBottom: "16px",
  // },

  // btnCal_wrp: {
  //   display: "inline-block",
  //   width: "100%",
  //   position: "relative",
  //   zIndex: 10,
  // },

  // btnCal_click: {
  //   border: "0.0625rem solid #cfd0d3",
  //   backgroundColor: "transparent",
  //   width: "100%",
  //   padding: "0.75rem",
  //   cursor: "pointer",
  //   borderRadius: 0,
  //   fontSize: "0.875rem",
  //   lineHeight: 1.4,
  //   "& input[type='time']::-webkit-calendar-picker-indicator": {
  //     right: "-10px",
  //     position: "absolute",
  //     width: "78px",
  //     height: "40px",
  //     color: "rgba(204, 204, 204, 0)",
  //     opacity: 0,
  //   },

  //   "& ::-webkit-inner-spin-button": {
  //     "& -webkit-appearance": "none",
  //   },
  //   "& ::-webkit-clear-button": {
  //     marginRight: "75px",
  //   },
  // },

  // btnCal: {
  //   background: "transparent",
  //   border: "none",
  //   color: "black",
  //   padding: "15px",
  //   position: "absolute",
  //   right: 0,
  //   top: 0,
  // },
}));
